import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    slideContainer: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    slideTitle: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(3),
        fontSize: "24px !important",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        textAlign: "start",
    },
    chartContainer: {
        flex: 1,
        minHeight: 0,
        padding: `${theme.spacing(3)} 0`,
    },
}));
